import citations from './generated-ai-citations.json' with {type: 'json'};
import {docsBasePath, siteOrigin} from '../site-config.mjs';

// Pagefind also indexes the source pages behind the combined API references.
// Resolve those results to the published operation instead of its Markdown page.
export function searchResultRoute(href, basePath = docsBasePath, currentOrigin = typeof window === 'undefined' ? siteOrigin : window.location.origin) {
  const url = new URL(href, currentOrigin);
  if (url.origin !== siteOrigin && url.origin !== currentOrigin) return href;
  const base = (basePath || '').replace(/\/$/, '');
  const stripBase = path => base && (path === base || path.startsWith(`${base}/`))
    ? path.slice(base.length) || '/' : path;
  const path = stripBase(url.pathname).replace(/\/$/, '').replace(/\.(?:md|mdx)$/, '') || '/';
  const citation = citations[`${docsBasePath}${path}`];
  if (citation) {
    const target = new URL(citation.url);
    return `${stripBase(target.pathname)}${url.search}${target.hash}`;
  }
  return `${path}${url.search}${url.hash}`;
}

// Redirect saved URLs and old search indexes as well as newly rendered results.
export const apiSourceRedirects = Object.entries(citations).flatMap(([source, citation]) => {
  const target = new URL(citation.url);
  if (target.pathname === source || !target.pathname.includes('/api/')) return [];
  return [{from: source.slice(docsBasePath.length), to: `${target.pathname.slice(docsBasePath.length)}${target.hash}`}];
});
